import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AppError } from '../../models/app-error';
import { AsyncPipe } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [AsyncPipe, SvgIconComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  clipboard = inject(Clipboard);
  showLogoutLink = false;
  isCopied = false;

  error$ = this.route.queryParams.pipe<AppError>(
    switchMap((params) => of(new AppError(params['code'], params['id']))),
  );

  ngOnInit(): void {
    const visitCount =
      Number(sessionStorage.getItem('errorPageVisits') || '0') + 1;
    sessionStorage.setItem('errorPageVisits', visitCount.toString());
    if (visitCount > 2) {
      this.showLogoutLink = true;
    }
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  copyToClipboard(text: string) {
    this.clipboard.copy(text);
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 1500);
  }

  onForceLogout(): void {
    localStorage.clear();
    sessionStorage.removeItem('errorPageVisits');
    this.router.navigate(['/login']);
  }
}
